// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ThumbUpOutlineComponent} from './ThumbUpOutline.svg';

import Icon, { TIconProps } from '../Icon';

export const IconThumbUpOutline = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ThumbUpOutlineComponent/>
  </Icon>
));
